var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10687",
    "data-name": "Group 10687",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.286,
    height: 16,
    viewBox: "0 0 18.286 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3035",
    "data-name": "Rectangle 3035",
    width: 18.286,
    height: 16,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10686",
    "data-name": "Group 10686",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28441",
    "data-name": "Path 28441",
    d: "M16.762,5.591l-.107-.258a1.143,1.143,0,0,0,0-2.286h-.937L14.865.92A1.916,1.916,0,0,0,13.234,0H5.052A1.933,1.933,0,0,0,3.389.984L2.56,3.048H1.615a1.143,1.143,0,0,0,0,2.286l-.091.258A2.67,2.67,0,0,0,0,8v3.81a1.9,1.9,0,0,0,1.524,1.865v1.182A1.143,1.143,0,0,0,2.667,16h.762a1.143,1.143,0,0,0,1.143-1.143V13.714h9.143v1.143A1.143,1.143,0,0,0,14.857,16h.762a1.143,1.143,0,0,0,1.143-1.143V13.675a1.9,1.9,0,0,0,1.524-1.865V8a2.67,2.67,0,0,0-1.524-2.409M16.67,3.81A.384.384,0,0,1,17,4.393a.386.386,0,0,1-.325.179h-.341l-.306-.762ZM2.56,5.1l.611-1.524.9-2.286A1.159,1.159,0,0,1,5.052.762h8.182a1.149,1.149,0,0,1,.953.5l1.63,4.068H2.469Zm-.945-.531a.381.381,0,1,1,0-.762h.67l-.306.762ZM3.81,14.857a.381.381,0,0,1-.381.381H2.667a.381.381,0,0,1-.381-.381V13.714H3.81Zm1.988-1.9.441-2.286h5.821l.445,2.286Zm10.2,1.9a.381.381,0,0,1-.381.381h-.762a.381.381,0,0,1-.381-.381V13.714H16Zm1.524-3.048a1.143,1.143,0,0,1-1.143,1.143H13.266l-.528-2.734a.378.378,0,0,0-.373-.314H5.921a.378.378,0,0,0-.373.314l-.528,2.734H1.9A1.143,1.143,0,0,1,.762,11.81V8a1.905,1.905,0,0,1,1.9-1.9H15.619a1.905,1.905,0,0,1,1.9,1.9ZM4.952,6.857H2.667A1.143,1.143,0,0,0,1.524,8v.762a.381.381,0,0,0,.381.381H4.952a.381.381,0,0,0,.381-.381V7.238a.381.381,0,0,0-.381-.381M4.571,8.381H2.286V8a.381.381,0,0,1,.381-.381h1.9ZM2.667,9.9A1.143,1.143,0,1,0,3.81,11.048,1.143,1.143,0,0,0,2.667,9.9m0,1.524a.381.381,0,1,1,.381-.381.381.381,0,0,1-.381.381m8.381-3.81H8a.381.381,0,1,0,0,.762h3.048a.381.381,0,0,0,0-.762m4.571-.762H13.333a.381.381,0,0,0-.381.381V8.762a.381.381,0,0,0,.381.381h3.048a.381.381,0,0,0,.381-.381V8a1.143,1.143,0,0,0-1.143-1.143M16,8.381H13.714V7.619h1.9A.381.381,0,0,1,16,8ZM15.619,9.9a1.143,1.143,0,1,0,1.143,1.143A1.143,1.143,0,0,0,15.619,9.9m0,1.524A.381.381,0,1,1,16,11.048a.381.381,0,0,1-.381.381",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car_icon.c7f5067ade2aa0755c591ab2ace357db.svg";
export { ForwardRef as ReactComponent };